import { Outlet, createFileRoute } from "@tanstack/react-router";

/** Layout-only route. The list lives in ``_auth.settings.mailboxes.index.tsx``;
 * detail in ``_auth.settings.mailboxes.$mailboxId.tsx``. Both render through
 * this Outlet — without it, navigating to /settings/mailboxes/$mailboxId would
 * mount the list page (the previous "leaf" component) and the child would
 * have no place to render. */
function MailboxesLayout() {
  return <Outlet />;
}

export const Route = createFileRoute("/_auth/settings/mailboxes")({
  component: MailboxesLayout,
});
